"use client"

import dynamic from 'next/dynamic';
import Loading from '@/components/shared/Loading';

const MapBoxMap = dynamic(() => import('@/components/shared/MapBoxMap'), {
  loading: () => <Loading />,
  ssr: false, // important for map components that need window/document
});

export default function MapBoxMapWrapper(props) {
  return <MapBoxMap {...props} />;
}

